<div>
   <app-header></app-header>
</div>
<div class="main">
    <div Class="row m-0 ">
        <div class="col-lg-12 bg-white py-3">
            <div class="upperimgdata bg-white">
                <div class="change-manage-notifications-container">
                    <div class="d-flex flex-column">
                        <h4>{{ termsOfUseData.title || 'Terms of Use' }}</h4>
                        <span><b class="bld-text">Settings<span class="mx-2">/</span></b><span
                                class="semi-bld-text">{{termsOfUseData.title || 'Terms of Use'}}</span></span>
                    </div>
                    <!-- <div class="terms_of_uses_content">
                        <div class="terms_of_uses">
                            <ul class="terms-ofuses-list">
                                <li *ngFor="let point of termsList;">
                                    <p>{{ point }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="custom-checkbox">
                                <label>
                                    <input type="checkbox" />
                                    <span class="checkmark"></span> I accepted the Terms of Use
                                </label>
                            </div>
                            <button type="submit" class="terms-of-use-submit-btns"
                                (click)="handleSaveChangesClick()">Save Changes</button>
                        </div>
                    </div> -->
                    <div class="terms_of_uses_content">
                        <!-- Check if termsList has data -->
                        <div *ngIf="termsList!.length > 0; else noTerms">
                          <div class="terms_of_uses">
                            <ul class="terms-ofuses-list">
                              <li *ngFor="let point of termsList">
                                <p>{{ point }}</p>
                              </li>
                            </ul>
                          </div>
                          <!-- <div class="d-flex justify-content-between align-items-center">
                            <div class="custom-checkbox">
                              <label>
                                <input type="checkbox" />
                                <span class="checkmark"></span> I accepted the Terms of Use
                              </label>
                            </div>
                            <button type="submit" class="terms-of-use-submit-btns text-white" (click)="handleSaveChangesClick()">
                              Save Changes
                            </button>
                          </div> -->
                        </div>
                        <ng-template #noTerms>
                          <div class="no-terms">
                            <p>No terms available at the moment. Please check back later.</p>
                          </div>
                        </ng-template>
                      </div>
                      
                </div>
            </div>
        </div>
    </div>
</div>
<div>
  <app-footer></app-footer>
</div>